import { useMutation } from "@tanstack/react-query";
import { graphierQLNextClient } from "utils";
import {
	GenerateSpatialQueryDownloadLinkMutation,
	GenerateSpatialQueryDownloadLinkMutationVariables,
} from "~map-view/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	mutation GenerateSpatialQueryDownloadLink(
		$input: SpatialQueryInput!
		$format: OUTPUT_FORMAT!
	) {
		generateSpatialQueryDownloadLink(input: $input, format: $format)
	}
`;

export const useGenerateSpatialQueryDownloadLink = () => {
	return useMutation({
		mutationKey: ["generateSpatialQueryDownloadLink"],
		mutationFn: (
			variables: GenerateSpatialQueryDownloadLinkMutationVariables,
		) =>
			graphierQLNextClient<
				GenerateSpatialQueryDownloadLinkMutation,
				GenerateSpatialQueryDownloadLinkMutationVariables
			>({
				query,
				variables,
				useKey: true,
			}).then((res) => res.generateSpatialQueryDownloadLink),
	});
};
